// @ts-nocheck


import React from 'react';


import AutocompleteSelect from './AutocompleteSelect';

import { contractVehicleApi } from '../../lib/api';
import { convertContractVehicleToString } from '../../lib/helpers';






const defaultOptionName = (contractVehicle) =>
convertContractVehicleToString(contractVehicle);

export default ({
  optionTitle = defaultOptionName,
  filters,
  ...selectProps
}) =>
<AutocompleteSelect
  placeholder="Выберите ТС"
  fetch={async (params) =>
  contractVehicleApi.fetchContractVehicles({ ...filters, ...params })
  }
  fetchSingle={contractVehicleApi.fetchContractVehicle}
  notFoundText="ТС не найдены"
  renderOption={(contractVehicle, Option) =>
  <Option
    key={contractVehicle.id}
    value={contractVehicle.id}
    vehicle={contractVehicle}>

        {optionTitle(contractVehicle)}
      </Option>
  }
  {...selectProps} />;
